<template>
  <div>
    <table class="ts-w-full ts-mt-3">
      <thead>
        <tr class="ts-bg-gray-200 ts-border-b ts-border-t">
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-3">
            {{ $t('borrowingSparePart.no') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24">
            {{ $t('borrowingSparePart.borrowingNumber') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-40">
            {{ $t('borrowingSparePart.barcode') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-56">
            {{ $t('borrowingSparePart.product') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24">
            {{ $t('borrowingSparePart.uom') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-32 ts-text-center">
            {{ $t('borrowingSparePart.qtyOrder') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-32 ts-text-center">
            {{ $t('borrowingSparePart.qtyReturn') }}
          </th>
          <th
            class="
              ts-px-3 ts-py-2 ts-uppercase ts-w-32 ts-text-right ts-bg-gray-100
            "
          >
            {{ $t('borrowingSparePart.unitPrice') }}
          </th>
          <th
            class="
              ts-px-3 ts-py-2 ts-uppercase ts-bg-gray-100 ts-border-r ts-w-24
            "
          >
            {{ $t('borrowingSparePart.cusR') }}
          </th>
          <th
            class="
              ts-px-3
              ts-py-2
              ts-uppercase
              ts-bg-gray-100
              ts-border-r
              ts-w-24
              ts-text-center
            "
          >
            {{ $t('borrowingSparePart.cusR%') }}
          </th>
          <th
            class="
              ts-px-3 ts-py-2 ts-uppercase ts-bg-gray-100 ts-w-40 ts-text-right
            "
          >
            {{ $t('borrowingSparePart.amount') }}
          </th>
          <th
            class="
              ts-px-3 ts-py-2 ts-uppercase
              vendor-part vendor-color
              ts-border-r ts-border-gray-200 ts-w-24 ts-whitespace-no-wrap
            "
          >
            {{ $t('borrowingSparePart.vendorRes') }}
          </th>
          <th
            class="
              ts-px-3 ts-py-2 ts-uppercase
              vendor-part vendor-color
              ts-border-r ts-border-gray-200 ts-w-24
            "
          >
            {{ $t('borrowingSparePart.vendor%') }}
          </th>
          <th
            class="
              ts-px-3 ts-py-2 ts-uppercase
              vendor-part vendor-color
              ts-w-32 ts-text-right ts-border-r ts-border-gray-200
            "
          >
            {{ $t('borrowingSparePart.stPrice') }}
          </th>
          <th
            class="
              ts-px-3 ts-py-2 ts-uppercase
              vendor-part vendor-color
              ts-w-32 ts-text-right
            "
          >
            {{ $t('borrowingSparePart.amount') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="ts-border-b"
          v-for="(p, index) in model.product_detail"
          :key="index"
        >
          <td class="ts-px-3 ts-py-2">{{ index + 1 }}</td>
          <td class="ts-px-3 ts-py-2">{{ p.sfo_number }}</td>
          <td class="ts-px-3 ts-py-2">{{ p.barcode }}</td>
          <td class="ts-px-3 ts-py-2">{{ p.product_name }}</td>
          <td class="ts-px-3 ts-py-2">
            <select class="ts-w-full ts-outline-none" v-model="p.uom_id">
              <option
                v-for="(u, index) in getUomList(p.product_id)"
                :key="index"
                :value="u.uom_id"
              >
                {{ u.uom_name_kh }}
              </option>
            </select>
          </td>
          <td class="ts-px-3 ts-py-2">
            <input
              :value="p.quantity_order"
              type="text"
              class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1"
              readonly
            />
          </td>
          <td class="ts-px-3 ts-py-2">
            <input
              v-model.number="p.quantity_return"
              type="number"
              class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1"
            />
          </td>
          <td class="ts-px-3 ts-py-2 ts-bg-gray-100">
            <ts-currency-input
              type="text"
              :value="p.sale_price * model.fx_rate_kh"
              currency="៛"
              class="
                ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2
              "
            />
          </td>
          <td class="ts-px-3 ts-py-2 ts-text-center ts-bg-gray-100 ts-border-r">
            <input
              :checked="p.customer_cover"
              type="checkbox"
              :true-value="true"
              :false-value="false"
            />
          </td>
          <td class="ts-px-3 ts-py-2 ts-bg-gray-100 ts-border-r">
            <input
              :value="p.customer_percentage"
              type="text"
              class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1"
              readonly
            />
          </td>
          <td class="ts-px-3 ts-py-2 ts-bg-gray-100 ts-border-r">
            <ts-currency-input
              currency="៛"
              type="text"
              :value="customerAmount(p)"
              class="
                ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2
              "
              readonly
            />
          </td>
          <td
            class="
              ts-px-3 ts-py-2 ts-text-center
              vendor-part
              ts-border-r ts-border-gray-200
            "
          >
            <input
              v-model="p.is_vendor_cover"
              type="checkbox"
              :true-value="true"
              :false-value="false"
            />
          </td>
          <td
            class="ts-px-3 ts-py-2 vendor-part ts-border-r ts-border-gray-200"
          >
            <input
              v-model="p.vendor_cover_percentage"
              type="number"
              class="
                ts-w-full ts-text-center ts-border ts-rounded ts-py-1
                vendor-color
              "
              readonly
            />
          </td>
          <td
            class="ts-px-3 ts-py-2 vendor-part ts-border-r ts-border-gray-200"
          >
            <ts-currency-input
              currency="฿"
              type="text"
              :value="p.vendor_standard_price * 32"
              class="
                ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2
                vendor-color
              "
              readonly
            />
          </td>
          <td class="ts-px-3 ts-py-2 vendor-part">
            <ts-currency-input
              type="text"
              currency="฿"
              :value="vendorRepAmount(p)"
              class="
                ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2
                vendor-color
              "
              readonly
            />
          </td>
        </tr>
        <tr>
          <td colspan="5" class="ts-text-right ts-px-3 ts-py-2">
            <strong>{{ $t('borrowingSparePart.total') }} : </strong>
          </td>
          <td class="ts-px-3 ts-py-2 ts-text-center">
            {{ $formatNumber(quantityOrder) }}
          </td>
          <td class="ts-px-2 ts-py-2 ts-text-center ts-pr-6">
            {{ $formatNumber(quantityReturn) }}
          </td>
          <td colspan="4" class="ts-px-5 ts-py-2 ts-text-right">
            {{ '៛ ' + $formatNumber(customerTotalAmount) }}
          </td>
          <td class="ts-px-5 ts-py-2 ts-text-right vendor-color" colspan="4">
            {{ '฿ ' + $formatNumber(vendorRepTotalAmount.toFixed(2)) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      priceType: 2,
      customerTotalAmount: 0,
      vendorRepTotalAmount: 0,
      quantityOrder: 0,
      quantityReturn: 0,
      model: {},
      tempDetails: [],
    }
  },
  computed: {
    customerAmount: (vm) => (product) => {
      return (
        ((product.sale_price *
          (product.quantity_order - product.quantity_return) *
          product.customer_percentage) /
          100) *
        vm.model.fx_rate_kh
      )
    },
    vendorRepAmount: (vm) => (product) => {
      let price =
        product.vendor_standard_price *
        (product.quantity_order - product.quantity_return)

      return ((price * product.vendor_cover_percentage) / 100) * 32
    },
    getUomList: (vm) => (productId) => {
      let uomList = vm.tempDetails.find((d) => d.product_id == productId)
      return uomList ? uomList.unit_of_measures : []
    },
  },
  created() {
    this.model = this.value
  },
  methods: {
    removeRow() {},
    sumQuantityOrder() {
      this.quantityOrder = 0
      this.model.product_detail.forEach((p) => {
        let quantity_order = p.quantity_order ? p.quantity_order : 0
        this.quantityOrder = this.quantityOrder + quantity_order
      })
    },
    sumQuantityReturn() {
      this.quantityReturn = 0
      this.model.product_detail.forEach((p) => {
        let quantity_return = p.quantity_return ? p.quantity_return : 0
        this.quantityReturn = this.quantityReturn + quantity_return
      })
    },
    sumCustomerAmount() {
      this.customerTotalAmount = 0
      this.model.product_detail.forEach((p) => {
        let CustomerAmount =
          ((p.sale_price *
            (p.quantity_order - p.quantity_return) *
            p.customer_percentage) /
            100) *
          this.model.fx_rate_kh

        this.customerTotalAmount = this.customerTotalAmount + CustomerAmount
      })
    },
    sumVendorRepAmount() {
      this.vendorRepTotalAmount = 0
      this.model.product_detail.forEach((p) => {
        let price =
          p.vendor_standard_price * (p.quantity_order - p.quantity_return)

        let VendorRepAmount = ((price * p.vendor_cover_percentage) / 100) * 32
        this.vendorRepTotalAmount = this.vendorRepTotalAmount + VendorRepAmount
      })
    },
  },
  watch: {
    'model.product_detail': {
      handler() {
        this.sumQuantityOrder()
        this.sumQuantityReturn()
        this.sumVendorRepAmount()
        this.sumCustomerAmount()
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.vendor-part {
  background: rgb(255, 255, 255);
}
.vendor-color {
  color: #fc4813;
  font-weight: 700;
}
</style>
